import React from 'react'
import { Link } from 'react-router-dom'
import SuperUserPageSF from './SuperUserPageSF'

const SuperUserHomePageUI = ({ context, className,
  topnav, backLink, headerText, subHeaderText,
  dimension, centered, children, page, onTypeChange
}) =>
  <SuperUserPageSF
    context={context}
    className={className}
    topnav={topnav}
    backLink={backLink}
    headerText={headerText}
    subHeaderText={subHeaderText}
    dimension={dimension}
    centered={centered}
    children={children}
    sideBar={
      <SideBarUI
        context={context}
        page={page}
      />
    }
    onTypeChange={onTypeChange}
  />

const SideBarUI = ({ context, page }) => {
  const isEmiTrackerActive = page === 'emi_tracker_2.0_business' || page === 'emi_tracker_2.0_retail' || page === 'emi_tracker_2.0' || page === 'repayments'
  return (
    <div className='t_sidebar'>
      {
        context.filter === 'classic' &&
        <>
          <SideBarItemUI label='Accounts' to='/su' active={page === 'accounts'} />
          <SideBarItemUI label='Loans' to='/su/loans' active={page === 'loans'} />
          <SideBarItemUI label='R.F. Loans' to='/su/receivableFinancing' active={page === 'rfLoans'} />
          <SideBarItemUI label='Repeat Transactions' to='/su/repeatTransactions' active={page === 'repeatTransaction'} />
          <SideBarItemUI label='Document Repository' to='/su/documentRepository' active={page === 'documentRepository'} />
        <hr />
          <SideBarItemUI label='EMI Tracker' to='/su/repayments/2.0' active={isEmiTrackerActive} />
          {/* <SideBarItemUI label='Compliance 2' to='/su/compliances' active={page === 'compliances'} /> */}
          <SideBarItemUI label='Fee Tracker' to='/su/fees' active={page === 'fees'} />
          <SideBarItemUI label='SI Report' to='/su/standingInstructionReport' active={page === 'standingInstructionReport'} />
          <SideBarItemUI label='Nach Report' to='/su/nachReport' active={page === 'nachReport'} />
          <SideBarItemUI label='Security Report' to='/su/security' active={page === 'dsra'} />
          <SideBarItemUI label='Lender Report' to='/su/lenders' active={page === 'lenders'} />
          <SideBarItemUI label='ALM Report' to='/su/almReport' active={page === 'almbucket'} />
          <SideBarItemUI label='Penalty Tracker' to='/su/penalty' active={page === 'penalty'} />
          <SideBarItemUI label='Compliance 2.0' to='/su/compliance' active={page === 'compliance'} />
          <SideBarItemUI label='Monitoring Intelligence' to='/su/monitoringIntelligence' active={page === 'monitoringIntelligence'} />
          <SideBarItemUI label='Disbursements' to='/su/disbursements' active={page === 'disbursements'} />
          <SideBarItemUI label='ESCC Account Validation Status' to='/su/escc-validation' active={page === 'esccValidation'} />
          <SideBarItemUI label='Vehicle Types' to='/su/vehicles' active={page === 'vehicles'} />
          <SideBarItemUI label='Yearly Income' to='/su/income' active={page === 'income'} />
          <hr />
          {/* <SideBarItemUI label='Compliance' to='/su/csStatus' active={page === 'csStatus'} /> */}
          <SideBarItemUI label='Distribution' to='/su/distribution' active={page === 'distribution'} />
          <SideBarItemUI label='Days Past Due' to='/su/dpd' active={page === 'daysPastDue'} />
          <SideBarItemUI label='Risk Register' to='/su/riskRegister' active={page === 'riskRegister'} />
          <SideBarItemUI label='Calendar' to='/su/calendar' active={page === 'calendar'} />
          <hr />
          <SideBarItemUI label='Recent Chats' to='/su/chats/recent' active={page === 'recentChat'} />
          <SideBarItemUI label='Clime Docs' to='/su/docs' active={page === 'docs'} />
          <a className='t_sidebar_item' target='_blank' href='https://climefinance.blogspot.com'><span className='g_no_wrap'>Clime Blog</span></a>
          <hr />
          <SideBarItemUI label='Leads' to='/su/leads' active={page === 'leads'} />
          <SideBarItemUI label='Sales Targets' to='/su/salesTargets/report' active={page === 'salesTargets'} />
          <SideBarItemUI label='Sales Report' to='/su/salesReport' active={page === 'salesReport'} />
          <SideBarItemUI label='Message Approvals' to='/su/messageApprovals' active={page === 'messageApprovals'} />
          <SideBarItemUI label='Escrow Balance' to='/su/virtualAccountBalances' active={page === 'virtualAccounts'} />
          {/* <SideBarItemUI label= 'Vendor Diligence' to='/su/vendorDiligence' active={page === 'vendorDiligence'} /> */}
          {
            (context.permissions && (context.permissions.includes('su_developer') || context.permissions.includes('su_superuser_business'))) &&
            <>
              <SideBarItemUI label='External Api' to='/su/failedExternal' active={page === 'failedExternal'} />
              <SideBarItemUI label='External Data Cache' to='/su/externalDataCache' active={page === 'externalDataCache'} />
            </>
          }
        </>
      }
      {
        context.filter === 'stp' &&
        <>
          <SideBarItemUI label='Accounts' to='/su' active={page === 'accounts'} />
          <SideBarItemUI label='Loans' to='/su/loans' active={page === 'loans'} />
          <hr />
          <SideBarItemUI label='EMI Tracker' to='/su/repayments/2.0' active={isEmiTrackerActive} />
          <SideBarItemUI label='Nach Report' to='/su/nachReport' active={page === 'nachReport'} />
          <SideBarItemUI label='Lender Report' to='/su/lenders' active={page === 'lenders'} />
          <SideBarItemUI label='Disbursements' to='/su/disbursements' active={page === 'disbursements'} />
          <hr />
          <SideBarItemUI label='Distribution' to='/su/distribution' active={page === 'distribution'} />
          {/* <SideBarItemUI label='Days Past Due' to='/su/dpd' active={page === 'daysPastDue'} /> */}
        </>
      }
    </div>
  )
}

const SideBarItemUI = ({ label, to, active }) =>
  <Link to={to} className={`${active ? 'active' : ''} t_sidebar_item`}>
    {label}
  </Link>

export default SuperUserHomePageUI

